
import { useEffect, useState } from "react";
import HowTo from "./HowTo";

const HowToPage = ({successHandler}) => {
    return (
        <div className="flex flex-col mx-auto p-4 md:p-10">
            {/* Simple and clear back button - FIXED */}
            <div className="mb-6">
                <button 
                    className="inline-flex items-center gap-2 px-4 py-2 text-gray-600 hover:text-gray-900 hover:bg-gray-100 rounded-lg transition-all duration-200 font-medium group"
                    onClick={() => { successHandler(false) }}      
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 group-hover:-translate-x-1 transition-transform" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
                    </svg>
                    Back to Main View
                </button>
            </div>
            
            <HowTo />
        </div>
    )
}

export default HowToPage;
